export const prefix = "bat"
export const iconName = "plus"
export const width = 20
export const height = 20
export const ligatures = []
export const unicode = ""
export const svgPathData =
    "M11.2349 11.1344H18.1478C18.4756 11.1347 18.7901 11.0047 19.0221 10.7731C19.2541 10.5416 19.3846 10.2273 19.3849 9.89949C19.3852 9.5717 19.2553 9.25721 19.0237 9.02521C18.7921 8.79322 18.4778 8.66273 18.15 8.66244L11.2371 8.66244L11.2371 1.74946C11.2371 1.42138 11.1067 1.10673 10.8747 0.874732C10.6427 0.642739 10.3281 0.512406 10 0.512406C9.67191 0.512406 9.35726 0.642739 9.12527 0.874732C8.89327 1.10673 8.76294 1.42138 8.76294 1.74946L8.76294 8.66244L1.84997 8.66244C1.52188 8.66244 1.20723 8.79277 0.975237 9.02476C0.743244 9.25676 0.612912 9.57141 0.612911 9.8995C0.612912 10.2276 0.743244 10.5422 0.975238 10.7742C1.20723 11.0062 1.52188 11.1366 1.84997 11.1366L8.76294 11.1366L8.76294 18.0495C8.76294 18.3776 8.89327 18.6923 9.12527 18.9243C9.35726 19.1563 9.67191 19.2866 10 19.2866C10.3281 19.2866 10.6427 19.1563 10.8747 18.9243C11.1067 18.6923 11.2371 18.3776 11.2371 18.0495L11.2349 11.1344Z"

export const definition = {
    prefix,
    iconName,
    icon: [ width, height, ligatures, unicode, svgPathData ],
}

export const batPlus = definition
